import t from "@ext/localization/locale/translate";
import { exportLogs } from "@ext/loggers/opentelemetry/exportLogs";
import { Button } from "@ui-kit/Button";
import { useState } from "react";

const ExportSessionLogsButton = () => {
	const [isExporting, setIsExporting] = useState(false);

	const onClick = async () => {
		setIsExporting(true);
		try {
			await exportLogs("session");
		} finally {
			setIsExporting(false);
		}
	};

	return (
		<Button
			disabled={isExporting}
			onClick={() => void onClick()}
			startIcon={isExporting ? "loader-circle" : "download"}
			variant="ghost"
		>
			{t("export-logs.title")}
		</Button>
	);
};

export default ExportSessionLogsButton;
